import {ApplicationEvent} from './application-event.model';
import {ApplicationEventType, ApplicationSearchEventSource} from '../constants';

export class SearchApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.Search;

  constructor(private term: string,
              private source: ApplicationSearchEventSource,
              private autoCorrectedTerm?: string,
              private expiredPromoTag?: boolean,
              private hasFilters?: boolean,
              private searchPageNumber?: number,
              private searchResultTotal?: number,
              private content?: string) {}

  getPayload(): SearchApplicationEventPayload {
    return {
      GA360_query: this.term,
      source: this.source,
      GA360_autoCorrectedQuery: this.autoCorrectedTerm,
      expiredPromoTag: this.expiredPromoTag,
      hasFilters: this.hasFilters,
      searchTermSent: this.autoCorrectedTerm,
      searchPageNumber: this.searchPageNumber,
      GA360_regularResults: this.searchResultTotal,
      content: this.content,
      label: this.term
    };
  }
}

export interface SearchApplicationEventPayload {
  GA360_query: string;
  source: ApplicationSearchEventSource;
  GA360_autoCorrectedQuery?: string;
  expiredPromoTag?: boolean;
  hasFilters?: boolean;
  searchTermSent?: string;
  searchPageNumber?: number;
  GA360_regularResults?: number;
  content?: string;
  label?: string;
}
